module.exports = __webpack_public_path__ + "media/images/lb/800-785aad501700f158478a3b9162de4df6.svg";